export default(state = [], action) =>{
    let query = {};
    switch(action.type){
        case 'INIT_QUERY_SELECTION_VALUES':
            return action.payload.map(q => ({ 
                code: q.code,
                selection: {
                    filter: null,
                    values: []
                }
            }));
        case 'SET_QUERY_VALUES':
            query = {
                code: action.payload.code,
                selection: {
                    filter: 'item',
                    values: action.payload.values
                }
            }
            return state.map(q => (q.code === action.payload.code ? query : q));
        case 'SET_QUERY_ALL_VALUES':
            query = {
                code: action.payload,
                selection: {
                    filter: 'all',
                    values: ["*"]
                }
            }
            return state.map(q => (q.code === action.payload ? query : q));
        default:
            return state;
    }
}